import { useState } from 'react';

const useFetch = (option={}) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

    const abortController = new AbortController();
    const signal = abortController.signal;
    const fetchData = async (url:string) => {

      try {
        setLoading(true)
        const response = await fetch(url,{ ...option, signal });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json(); 
        setData(result);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

  return { data, loading, error,fetchData };
};

export default useFetch;